import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../filters';
import users from '@/users';

export default {
  name: 'customerEventLog',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users],
  props: {
    custkey: {
      type: String,
      required: true
    },
    isRtl: {
      type: Boolean,
      required: true
    },
    empName: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      addLog: {
        user: '',
        date: '',
        description: '',
        type: ''
      },
      eventLogPageingoptions: { pageSize: 10, total: 0, page: 1 },
      EventLog: [],
      eventLogTotalRow: 0,
      EventLogCols: [],
      showDialog: false,
      othersEdit: false,
      enquiriesEdit: false,
      selectedLog: {},
    }
  },
  computed: {
    eventLogButtonLabel: function() {
      return `${this.$t('attachments.Add')} ${this.$t('enquiriesCustomerDetails.eventLog')}`;
    },
    editButtonDisabled: function () {
      return !(this.selectedLog != null && this.selectedLog.data != null && this.selectedLog.data.createDate);
    }
  },
  created() {
    this.fillCols();
    this.fillEventLog();
  },
  methods: {
    fillCols() {
      this.EventLogCols = [];
      this.EventLogCols.push({ dataField: 'stampDate', caption: this.$t('ApplicationsGrid.lastEditDate'), dataType: 'date' });
      this.EventLogCols.push({ dataField: 'lastEditedBy', caption: this.$t('enquiriesCustomerDetails.Share') });
      this.EventLogCols.push({ dataField: 'createdBy', caption: this.$t('ApplicationsGrid.creationUser') });
      this.EventLogCols.push({ dataField: 'createDate', caption: this.$t('samples.CreationDate'), dataType: 'date' });
      this.EventLogCols.push({ dataField: 'description', caption: this.$t('ApplicationsGrid.description') });
      this.EventLogCols.push({ dataField: 'sourceType', caption: this.$t('ApplicationsGrid.sourceType') });
      this.EventLogCols.push({ dataField: 'sourceId', caption: this.$t('enquiriesCustomerDetails.sourceId') });
    },
    eventLogPageChange(pInfo) {
      this.eventLogPageingoptions.page = pInfo.pageNumber;
      this.eventLogPageingoptions.pageSize = pInfo.pageSize;
      this.fillEventLog();
    },
    fillEventLog() {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.eventLogPageingoptions
      }

      axios.post('/Enquiries/GetEventLog', parameters)
        .then(response => {
          if (response.status == 200) {
            this.EventLog = response.data.items;
            this.eventLogTotalRow = response.data.itemsCount;

            this.othersEdit = response.data.othersEdit;
            this.enquiriesEdit = response.data.enquiriesEdit;
          }
        })
        .catch(e => { return false; });
    },
    openEventLog(item) {
      if (!this.enquiriesEdit || !item.data || !item.data.createdBy || !item.data.lastEditedBy)
        return;

      if (!this.othersEdit && this.empName != item.data.stampUser) {
        this.$oldAlertMsg(this.$t('enquiriesPropertyDetails.OtherUserEditError'), 3);
        return;
      }

      let dte = moment().format('DD/MM/YYYY');
      this.addLog = {
        ...item.data,
        stampDateDisplay: dte,
        lastEditedBy: this.empName,
        type: 'edit'
      };

      this.showDialog = true;
    },
    eventLogSelected(item) {
      console.log(item);
      this.selectedLog = item;
    },
    openDialog() {
      let dte = moment().format('DD/MM/YYYY');
      this.addLog = {
        lastEditedBy: this.empName,
        stampDateDisplay: dte,
        description: '',
        createdBy: this.empName,
        createDate: dte,
        type: 'add'
      };

      this.showDialog = true;
    },
    save() {
      if (this.enquiriesEdit == false)
        return;

      var parameters = {
        Custkey: this.custkey,
        Description: this.addLog.description,
      }

      if (this.addLog.type == 'edit') {
        parameters['SourceId'] = this.addLog.sourceId;
        parameters['EventId'] = this.addLog.eventId;
        parameters['IsEvent'] = this.addLog.isEvent;
      }
        

      axios.post('/Enquiries/AddOrUpdateEventLog', parameters)
        .then(response => {
          if (response.status == 200) {
            this.$oldAlertMsg(this.$t('enquiriesPropertyDetails.EventSaved'), 2);
            this.fillEventLog();
            this.showDialog = false;
          }
          else
            this.$oldAlertMsg(this.$t('enquiriesPropertyDetails.EventSaveError'), 4);
        })
        .catch(e => {
          this.$oldAlertMsg(this.$t('enquiriesPropertyDetails.EventSaveError'), 4);
        });
    },
  },
}

